import React from 'react';
import Page from '../components/page/Page';
var AccessDenied = function() {
    return /*#__PURE__*/ React.createElement(Page, null, /*#__PURE__*/ React.createElement("p", {
        className: "main-font"
    }, "403"), /*#__PURE__*/ React.createElement("p", {
        className: "normal-font"
    }, "Access Denied"));
};
export default AccessDenied;
